import * as React from 'react';
import InputLabel, { InputLabelProps } from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MUISelect from '@mui/material/Select';
import MUIMenuItem from '@mui/material/MenuItem';
import { SelectInputProps } from '@mui/material/Select/SelectInput';
import {
  MenuItemProps,
  FormHelperText,
  useTheme,
  styled,
  Theme,
} from '@mui/material';

import ChevronDownIcon from './icon/chevron-down-icon';
import ChevronUpIcon from './icon/chevron-up-icon';

export type SelectOptionProps = MenuItemProps;
export interface SelectProps
  extends Omit<SelectInputProps, 'autoWidth' | 'multiple' | 'native'> {
  children: React.ReactNodeArray | React.ReactNode;
  label?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  autoWidth?: boolean;
  multiple?: boolean;
  native?: boolean;
  defaultValue?: string | number | string[];
}
export interface SelectComposition extends React.FC<SelectProps> {
  Option: React.FC<SelectOptionProps>;
}

export interface CustomInputLabelProps extends InputLabelProps {
  type: string | undefined;
  theme: Theme;
}
const BrandedSelectOption = styled(MUIMenuItem)`
  padding: '16px';
`;

const StyledFormControl = styled(FormControl)(
  ({ theme }: { theme: Theme }) => ({
    // () => ({
    '& .MuiInput-root.Mui-focused': {
      color: theme.palette.greyscale.white,
    },
    '& .MuiInput-underline.Mui-focused:after': {
      borderColor: '#45C7FF',
    },
    '&:hover .MuiInput-underline:before': {
      borderColor: '#45C7FF',
    },
    '& .MuiInputLabel-shrink': {
      color: '#b0b0b0',
    },
  }),
);
const Select: SelectComposition = ({
  children,
  label,
  helperText,
  variant,
  error,
  disabled,
  ...props
}) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <StyledFormControl
      variant="standard"
      fullWidth
      error={error}
      disabled={disabled}
      color={error ? 'error' : 'primary'}
    >
      {label && <InputLabel color="secondary">{label}</InputLabel>}

      <MUISelect
        labelId={`select-${label}`}
        variant={variant}
        MenuProps={{
          color: 'secondary',
          sx: {
            '.MuiMenu-list': {
              backgroundColor: '#142341',
              '.Mui-selected': {
                backgroundColor: '#45C7FF',
                color: theme.palette.greyscale.black,
              },
              '.Mui-selected:hover': {
                backgroundColor: theme.palette.cyan,
                color: theme.palette.greyscale.black,
              },
            },
          },
        }}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        IconComponent={() => (isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />)}
        {...props}
      >
        {children}
      </MUISelect>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </StyledFormControl>
  );
};
Select.Option = BrandedSelectOption;

export default Select;
